import { basketDataSelector } from 'components/Basket/selectors'
import { findCinemaId } from 'global/helpers'
import { getCinemaSlug } from 'pages/Hall/helpers'
import { select } from 'redux-saga/effects'

export default function* gtmRemoveTickets(ticketids) {
    const cinemaid = yield select((state) => findCinemaId(state))
    const basketData = yield select(basketDataSelector)
    const site = getCinemaSlug(cinemaid)
    const ref = window.localStorage.getItem('referer')

    const items = []

    basketData?.items_tickets?.forEach((eventTickets) => {
        const ticketsToRemove = eventTickets.tickets.filter((ticket) => ticketids.includes(ticket.ticketid))
        const eventItems = ticketsToRemove.map((item) => {
            return {
                affiliation: 'Cinestar',
                coupon: '',
                item_list_id: ref,
                item_list_name: ref,
                item_id: eventTickets.event.eventid,
                item_name: eventTickets.event.title,
                item_brand: site,
                item_category: 'Nákup',
                item_category_2: 'Film',
                discount: 0.0,
                price: item.price,
                quantity: 1,
            }
        })
        items.push(...eventItems)
    })

    dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
    dataLayer.push({
        event: 'remove_from_cart',
        ecommerce: {
            currency: 'CZK',
            value: basketData.price,
            items: [...items],
        },
    })
}
